<template>

    <div class="com-news-list-v-rank">
        <ul>
            <li v-for="(item,idx) in list" :key="item.id">
                <a :href="tplGetDetailLink(item)" class="block flex justify-between" target="_blank">
                    <div class="flex">
                        <div :class="idx<3 ? ('nums idx'+idx) : 'nums'">{{idx + 1}}
                            <!-- {{idx > 2 ? '.' : ''}} -->
                        </div>
                        <div class="newsTit">{{item.title}}</div>
                    </div>

                    <div class="readNum">{{item.viewCount}}次阅读</div>
                </a>
            </li>
        </ul>
    </div>

</template>

<script>
import Utils from "@/utils/utils";

export default {
    props: {
        list: {
            type: Array,
            value: []
        }
    },

    data() {
        return {}
    },

    created() {

    },

    methods: {
        tplGetDetailLink(item) {
            return item.link || Utils.getPageUrl('detail', {id: item.id})
        },
    }

}
</script>

<style lang="less" scoped>

.com-news-list-v-rank {

    width: 370px;

    ul {
        padding-top: 8px;
    }

    li {
        cursor: pointer;
        margin-bottom: 16px;

        a{
            height: 18px;
        }

        .nums {
            width: 18px;
            height: 18px;
            text-align: center;
            padding-top: 1px;
            color: #8B9CB7;
        }

        .idx0 {
            background: #E62021;
            color: #fff;
        }

        .idx1 {
            background: #E65801;
            color: #fff;
        }

        .idx2 {
            background: #F5B330;
            color: #fff;
        }

        .newsTit {
            width: 260px;
            color: #363A3E;
            font-size: 16px;
            line-height: 19px;
            font-weight: 700;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-left: 10px;

        }

        .newsTit:hover {
            color: #f00;
        }

        .readNum {
            color: #8B9CB7;
            font-size: 11px;
            padding-top: 3px;
        }
    }

}


</style>
